import {
  get as _get
} from 'lodash';

export const getAtError = (err: any) => {
  return _get(err, ['response', 'data', 'error_description']) || _get(err, ['response', 'data', 'errorDescription']) || 'Unknown Error';
}